import React from "react";
import {Stack, Typography} from "@mui/material";
import {useTranslations} from "next-intl";
import {ColletteButton} from "@collette-travel/collette-common-controls";

interface SubmissionProps {
  handleClose: () => void;
  error?: boolean;
}

const RequestACallbackSubmissionMessage = ({
  handleClose,
  error = false
}: SubmissionProps) => {
  const t = useTranslations("FORMS");
  return (
    <Stack
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "center",
        gap: "2.4rem",
        padding: "4rem"
      }}
    >
      <Typography
        variant="h2"
        component="h5"
        data-testid="rac-submission-message-header"
      >
        {error ? t("There was an issue") : t("Thank You")}
      </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        data-testid="rac-submission-message-copy"
      >
        {error ? t("RAC.error message") : t("RAC.submission copy")}
      </Typography>
      <ColletteButton
        color="secondary"
        label={t("Close")}
        testId="rac-submission-message-close-button"
        onClick={handleClose}
        sx={{
          maxWidth: "9rem",
          "&:focus-visible": {
            backgroundColor: "secondary.dark"
          }
        }}
      />
    </Stack>
  );
};

export default RequestACallbackSubmissionMessage;